{
    "MFA_Setup_Title": "Setup Multi-Factor Authentication (MFA)",
    "MFA_Login_Title": "MFA Code Entry",
    "MFA_Setup_Description1": "Please scan the QR code below with your",
    "MFA_Setup_Description2": "authenticator app.",
    "MFA_Setup_Description3": "Then enter the code displayed in your app here.",
    "MFA_Login_Description3": "Please enter the code from your authenticator app to login.",
    "MFA_Login_Description": "Please enter the code from your authenticator app to login.",
    "MFA_Setup_Continue": "Complete MFA Setup",
    "MFA_Login_Continue": "Continue",
    "MFA_Setup_Cancel": "Cancel Setup",
    "MFA_Login_Cancel": "Log out",
    "MFA_Authenticator_Help": "**What is an authenticator app?**\nAn authenticator app is a mobile app that generates a one-time password (OTP) for you to\nuse when logging in to your account.\n\n**Why do I need an authenticator app?**\nAn authenticator app is a more secure way to log in to your account.\n\n**How do I use an authenticator app?**\n##!##Download an authenticator app from the App Store or Google Play.####Open the app and scan the QR code.####Enter the six-digit code generated by the app.####Click \"Complete MFA Setup\".####!",
    "MFA_SessionMissing_Error": "Cognito Session is missing. Please try again.",

    "NAME": "MFALanguage"
}